export default __webpack_public_path__ + "static/media/py-icon.61929460.svg";